import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { installFetchLimiter } from './utils/fetchLimiter';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./context/AuthContext";
import { DepartmentProvider } from "./context/DepartmentContext";
import { DesignationProvider } from "./context/DesignationContext";
import { LeavesProvider } from './context/LeavesContext';
import { LeaveTypeProvider } from "./context/LeaveTypeContext";
import { ProjectTypeProvider } from "./context/ProjectTypeContext";
import { ProjectProvider } from "./context/ProjectContext";
import { PayrollProvider } from "./context/PayrollContext";
import { ClientsProvider } from './context/ClientContext';
import { RoleProvider } from "./context/RoleContext";
import { AttendanceProvider } from "./context/AttendanceContext";
import { TimesheetProvider } from "./context/TimesheetContext";
import { EmployeesProvider } from "./context/EmployeeContext";
import { HolidayProvider } from "./context/HolidayContext";
import { TaskProvider } from "./context/TaskContext";
import { CommentsProvider } from "./context/CommentsContext";
import { QRProvider } from "./context/QRContext";
import { DashboardProvider } from "./context/DashboardContext";
import { TaskBugsProvider } from './context/TaskBugsContext';
import { WorkProvider } from './context/WorkContext';
import { PasswordProvider } from './context/PasswordContext';
import { TaskProgressProvider } from './context/TaskProgressContext';
import { AttendanceReportProvider } from './context/AttendanceReportContext';
// import { LetterRequestsProvider } from './context/LetterRequestsContext';
import { AssetTypeProvider } from './context/AssetTypeContext';
import { AssetCategoryProvider } from './context/AssetCategoryContext';
import { PolicyCategoryProvider } from './context/PolicyCategoryContext';
import { PolicyProvider } from './context/PolicyContext';
import { CompanyAnnouncementProvider } from './context/CompanyAnnouncementContext';
import { AssetProvider } from './context/AssetContext';
import { AssetTicketProvider } from './context/AssetTicketContext';
import { ReturnAssetProvider } from './context/ReturnAssetContext';
import { CalendarProvider } from './context/CalendarContext';
import { ComplaintTypeProvider } from './context/ComplaintTypeContext';
import { ComplaintsProvider } from './context/ComplaintsContext';
import { BonusTypeProvider } from './context/BonusTypeContext';
import { BonusProvider } from './context/BonusContext';
import { DocumentTypeProvider } from './context/DocumentTypeContext';
import { DocumentProvider } from './context/DocumentContext';
import { CertificateProvider } from './context/CertificateContext';
import { ManagedashboardProvider } from './context/ManagedashboardContext';
import { PerformanceProvider } from './context/PerformanceContext';
import { AdminProjectInsightsProvider } from './context/AdminProjectInsightsContext';
import { OrganizationChartProvider } from './context/OrganizationChartContext';
import { ResumeProvider } from './context/ResumeContext';
import { InterviewProvider } from './context/InterviewContext';
import { OnboardingProvider } from './context/OnboardingContext';
import { ClearanceProvider } from './context/ClearanceContext';
import { RecruitmentDocumentProvider } from './context/Recruitmentdocumentcontext';
import { OffboardingProvider } from './context/Offboardingcontext';
import { AuditLogProvider } from './context/AuditLogContext';

// Must run before any provider mounts — 47 of the providers below fetch on
// mount, which over HTTP/2 opens ~47 connections at once and exceeds the
// backend host's Entry Processes cap of 40, producing 508s. See fetchLimiter.js.
installFetchLimiter();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="">
      <AuthProvider>
        <DepartmentProvider>
          <DesignationProvider>
            <LeavesProvider>
              <LeaveTypeProvider>
                <ProjectTypeProvider>
                  <ProjectProvider>
                    <PayrollProvider>
                      <ClientsProvider>
                        <RoleProvider>
                          <AttendanceProvider>
                            <TimesheetProvider>
                              <EmployeesProvider>
                                <HolidayProvider>
                                  <TaskProvider>
                                    <CommentsProvider>
                                      <QRProvider>
                                        <DashboardProvider>
                                          <TaskBugsProvider>
                                            <WorkProvider>
                                              <PasswordProvider>
                                                <TaskProgressProvider>
                                                  <AttendanceReportProvider>
                                                    {/* <LetterRequestsProvider> */}
                                                      <AssetTypeProvider>
                                                        <AssetCategoryProvider>
                                                          <PolicyCategoryProvider>
                                                            <PolicyProvider>
                                                              <CompanyAnnouncementProvider>
                                                                <AssetProvider>
                                                                  <AssetTicketProvider>
                                                                    <ReturnAssetProvider >
                                                                      <CalendarProvider>
                                                                        <ComplaintTypeProvider>
                                                                          <ComplaintsProvider>
                                                                            <BonusTypeProvider>
                                                                              <BonusProvider>
                                                                                <DocumentTypeProvider>
                                                                                  <DocumentProvider>
                                                                                    <CertificateProvider>
                                                                                      <ManagedashboardProvider>
                                                                                        <PerformanceProvider>
                                                                                          <AdminProjectInsightsProvider>
                                                                                            <OrganizationChartProvider>
                                                                                              <ResumeProvider>
                                                                                                <InterviewProvider>
                                                                                                  <OnboardingProvider>
                                                                                                    <ClearanceProvider>
                                                                                                      <RecruitmentDocumentProvider>
                                                                                                        <OffboardingProvider>
                                                                                                          <AuditLogProvider>
                                                                                                            <App />
                                                                                                          </AuditLogProvider>
                                                                                                        </OffboardingProvider>
                                                                                                      </RecruitmentDocumentProvider>
                                                                                                    </ClearanceProvider>
                                                                                                  </OnboardingProvider>
                                                                                                </InterviewProvider>
                                                                                              </ResumeProvider>
                                                                                            </OrganizationChartProvider>
                                                                                          </AdminProjectInsightsProvider>
                                                                                        </PerformanceProvider>
                                                                                      </ManagedashboardProvider>
                                                                                    </CertificateProvider>
                                                                                  </DocumentProvider>
                                                                                </DocumentTypeProvider>
                                                                              </BonusProvider>
                                                                            </BonusTypeProvider>
                                                                          </ComplaintsProvider>
                                                                        </ComplaintTypeProvider>
                                                                      </CalendarProvider>
                                                                    </ReturnAssetProvider>
                                                                  </AssetTicketProvider>
                                                                </AssetProvider>
                                                              </CompanyAnnouncementProvider>
                                                            </PolicyProvider>
                                                          </PolicyCategoryProvider>
                                                      </AssetCategoryProvider>
                                                      </AssetTypeProvider>
                                                    {/* </LetterRequestsProvider> */}
                                                  </AttendanceReportProvider>
                                                </TaskProgressProvider>
                                              </PasswordProvider>
                                            </WorkProvider>
                                          </TaskBugsProvider>
                                        </DashboardProvider>
                                      </QRProvider>
                                    </CommentsProvider>
                                  </TaskProvider>
                                </HolidayProvider>
                              </EmployeesProvider>
                            </TimesheetProvider>
                          </AttendanceProvider>
                        </RoleProvider>
                      </ClientsProvider>
                    </PayrollProvider>
                  </ProjectProvider>
                </ProjectTypeProvider>
              </LeaveTypeProvider>
            </LeavesProvider>
          </DesignationProvider>
        </DepartmentProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
